import { Component } from '@angular/core';
import { GridReadyEvent } from 'ag-grid-community';
import { GridApi } from 'ag-grid-enterprise';

import { lumFileName } from '@app/shared/utils/file.utils';
import { IGetApiResponse } from 'v2/modules/shared/interfaces/api-response.interface';
import { LumResponseError } from 'v2/shared/api/lum-response-error';
import { LumSnackBar } from 'v2/shared/lum-snack-bar/lum-snack-bar.service';

import { ICostLayer } from '../cost-layers.types';
import { CostLayersDataStore } from '../services/cost-layers.data-store';

//

@Component({
  selector: 'lum-cost-layers',
  templateUrl: './cost-layers.component.html',
  styleUrls: ['./cost-layers.component.scss'],
})
export class CostLayersComponent {
  basicTableGridApi :GridApi;

  constructor(
    private _snackBar :LumSnackBar,
    public store :CostLayersDataStore,
  ) {}

  handleExportButtonClick(e :PointerEvent) {
    e.preventDefault();

    this.basicTableGridApi.exportDataAsCsv({
      fileName: lumFileName('cost_layers'),
    });
  }

  handleGridReady(e :GridReadyEvent) {
    this.basicTableGridApi = e.api;
  }

  handleLoadError(error :LumResponseError) {
    this.store.updateState({ costLayersLoading: false });
    this._snackBar.openError(error.message);
  }
  handleLoadStart() {
    this.store.updateState({ costLayersLoading: true });
  }
  handleLoadSuccess(e :IGetApiResponse<ICostLayer[]>) {
    this.store.updateState({
      costLayers: e.data,
      costLayersPaging: e.meta,
      costLayersLoading: false,
    });
  }
}
